export default {
  product: {
    name: "Storefront",
    version: import.meta.env.VITE_BUILD_VERSION
  },
};
